module.exports = __webpack_public_path__ + "img/violet.be5030ca.webp";